const SAVED_ITEMS = 'savedItems';
const SAVED_ITEMS_NEW = 'saved-items/myFavorites';
const CART_SAVED_ITEMS = 'saved-items/savedForLater';

export default {
    SAVED_ITEMS,
    SAVED_ITEMS_NEW,
    CART_SAVED_ITEMS,
};
